import React from 'react'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import { localized } from 'decorators'
import { DashboardItem, formatters } from 'components/dashboard'
import { api } from 'store/modules/dashboard'

import { useStyles } from './index.css'

const DataRow = ({ localize, range, data }) => {
  return (
    <TableRow>
      <TableCell>{localize(`dashboard.sellsByTime_${range}`)}</TableCell>
      <TableCell align='right'>{formatters(localize).bottles(data[range].bottles)}</TableCell>
      <TableCell align='right'>{formatters(localize).prices(data[range].totalAcquisitionPrice)}</TableCell>
      <TableCell align='right'>{formatters(localize).prices(data[range].totalActualPrice)}</TableCell>
    </TableRow>
  )
}
export const SellsByTime = localized(({ localize }) => {
  const classes = useStyles()
  const [data, setData] = React.useState(null)
  const handleData = React.useCallback(x => setData(x), [])

  return (
    <DashboardItem
      title={localize('dashboard.sellsByTime_title')}
      dataSource={api.getSellsByTime}
      bodyClassName={classes.root}
      onDataReceived={handleData}>
      {data && <React.Fragment>
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>{localize('dashboard.sellsByTime_range')}</TableCell>
                <TableCell align='right'>{localize('dashboard.soldByChannels_bottles')}</TableCell>
                <TableCell align='right'>{localize('dashboard.soldByChannels_acquisition')}</TableCell>
                <TableCell  align='right'>{localize('dashboard.soldByChannels_actual')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <DataRow localize={localize} range='allTheTime' data={data} />
              <DataRow localize={localize} range='lastYear' data={data} />
              <DataRow localize={localize} range='thisYear' data={data} />
              <DataRow localize={localize} range='lastMonth' data={data} />
              <DataRow localize={localize} range='lastWeek' data={data} />
              <DataRow localize={localize} range='yesterday' data={data} />
            </TableBody>
          </Table>
        </React.Fragment>}
    </DashboardItem>
  )
})
